import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const token = localStorage.getItem('compleet_access_token');

  if (!token) {
    return router.createUrlTree(['/auth/login']);
  }

  return true;
};
